import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50">
        <div className="text-center">
          <div className="inline-block h-12 w-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mb-4"></div>
          <p className="text-gray-600">{t('website.common.loading') || 'Loading...'}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const setupPaths = [
    '/dashboard/profile-setup',
    '/dashboard/applicant-setup',
    '/dashboard/applicant-payment',
    '/dashboard/travel-details',
    '/dashboard/hotel',
    '/dashboard/visa-letter',
  ];
  const isSetupPath = setupPaths.includes(location.pathname);
  const role = typeof user?.role === 'string' ? user.role.toLowerCase().trim() : '';
  const isApplicant = role === 'applicant';
  const mustCompleteProfile =
    role !== 'admin' &&
    role !== 'super_admin' &&
    role !== 'superadmin' &&
    role !== 'organizer' &&
    !Boolean(user?.profile_completed);

  if (
    isApplicant &&
    !Boolean(user?.profile_completed) &&
    location.pathname !== '/dashboard/applicant-setup' &&
    location.pathname !== '/dashboard/applicant-payment'
  ) {
    return <Navigate to="/dashboard/applicant-setup" replace />;
  }

  if (mustCompleteProfile && !isSetupPath) {
    return <Navigate to="/dashboard/profile-setup" replace />;
  }

  return children;
};

export default ProtectedRoute;
